import { render, staticRenderFns } from "./TableDataBanner.vue?vue&type=template&id=4387d26a&"
import script from "./TableDataBanner.vue?vue&type=script&lang=js&"
export * from "./TableDataBanner.vue?vue&type=script&lang=js&"
import style0 from "./TableDataBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports